module.exports = __webpack_public_path__ + "img/robot_wuliu.b6ae1077.png";